import { createClient } from '@supabase/supabase-js'

// Only log environment variables in development
if (process.env.NODE_ENV === 'development') {
  console.log('🔍 Environment variables check:');
  console.log('REACT_APP_SUPABASE_URL:', process.env.REACT_APP_SUPABASE_URL);
  console.log('REACT_APP_SUPABASE_ANON_KEY:', process.env.REACT_APP_SUPABASE_ANON_KEY ? 'Present' : 'Missing');
  console.log('All REACT_APP env vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP')));
}

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables!');
  console.error('Make sure your .env file is in the project root and contains:');
  console.error('REACT_APP_SUPABASE_URL=https://your-project.supabase.co');
  console.error('REACT_APP_SUPABASE_ANON_KEY=your-anon-key');
  throw new Error('Missing Supabase configuration. Check your .env file.');
}

if (process.env.NODE_ENV === 'development') {
  console.log('✅ Supabase client initializing...');
}

// Enhanced Supabase client with better connection configuration
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'public',
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Enable email confirmation flow
    flowType: 'pkce'
  },
  global: {
    headers: {
      'x-my-custom-header': 'renovirai-app',
    },
  },
  // Add retry configuration for better reliability
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
}) 